import { render, staticRenderFns } from "./demonstration.vue?vue&type=template&id=1757a067&"
import script from "./demonstration.vue?vue&type=script&lang=js&"
export * from "./demonstration.vue?vue&type=script&lang=js&"
import style0 from "./demonstration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports